import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';

const Pricing = () => {
    const plans = [
        {
            name: "Core",
            price: "Free",
            features: ["5 Pipelines", "Basic Nodes", "Community Support", "1GB Storage"],
            color: "border-gray-600 shadow-gray-500/20"
        },
        {
            name: "Pro",
            price: "$49",
            period: "/mo",
            features: ["Unlimited Pipelines", "Advanced AI Nodes", "Priority Support", "100GB Storage", "Team Collaboration"],
            color: "border-neon-blue shadow-neon-blue/40",
            bestValue: true
        },
        {
            name: "Enterprise",
            price: "Custom",
            features: ["Dedicated Infrastructure", "Custom Node Development", "24/7 SLA Support", "Unlimited Storage", "On-Premise Deployment"],
            color: "border-neon-purple shadow-neon-purple/40"
        }
    ];

    return (
        <div className="min-h-screen bg-cyber-gray text-white font-rajdhani relative overflow-hidden">
            {/* Background Grid Animation */}
            <div className="absolute inset-0 z-0 opacity-10 pointer-events-none">
                <div className="absolute inset-0 bg-[linear-gradient(to_right,#80808012_1px,transparent_1px),linear-gradient(to_bottom,#80808012_1px,transparent_1px)] bg-[size:24px_24px]"></div>
            </div>

            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-32 pb-20 relative z-10">
                <div className="text-center mb-16">
                    <span className="text-neon-blue font-mono tracking-widest text-sm uppercase mb-4 block">Resource Allocation</span>
                    <h1 className="text-5xl md:text-7xl font-bold font-orbitron text-white mb-6">
                        PRICING MODELS
                    </h1>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                    {plans.map((plan, index) => (
                        <motion.div
                            key={index}
                            initial={{ opacity: 0, y: 50 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ delay: index * 0.2 }}
                            whileHover={{ y: -10 }}
                            className={`bg-gray-900/80 backdrop-blur-md border-2 ${plan.color} rounded-2xl p-8 relative flex flex-col shadow-lg`}
                        >
                            {plan.bestValue && (
                                <div className="absolute -top-4 left-1/2 transform -translate-x-1/2 bg-neon-blue text-black px-4 py-1 rounded-full font-bold text-sm shadow-[0_0_15px_rgba(0,243,255,0.6)] animate-pulse">
                                    OPTIMAL CHOICE
                                </div>
                            )}
                            <h3 className="text-2xl font-bold font-orbitron mb-2">{plan.name}</h3>
                            <div className="mb-8">
                                <span className="text-5xl font-bold">{plan.price}</span>
                                {plan.period && <span className="text-gray-400 text-lg">{plan.period}</span>}
                            </div>
                            <ul className="flex-1 space-y-4 mb-8">
                                {plan.features.map((feature, i) => (
                                    <li key={i} className="flex items-center text-gray-300">
                                        <Check className="w-5 h-5 text-green-400 mr-2" />
                                        {feature}
                                    </li>
                                ))}
                            </ul>
                            <button className={`w-full py-3 rounded-lg font-bold font-orbitron transition-all duration-300 ${plan.bestValue ? 'bg-neon-blue text-black hover:shadow-[0_0_20px_rgba(0,243,255,0.4)]' : 'bg-gray-800 hover:bg-gray-700 border border-gray-600'}`}>
                                {plan.name === 'Enterprise' ? 'CONTACT SALES' : 'INITIATE PLAN'}
                            </button>
                        </motion.div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default Pricing;
